import DesShareLibrarySearchResultsForTeamsViewModel from 'viewmodel/DesShareLibrarySearchResultsForTeamsViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesShareLibrarySearchResultsForTeams extends DesBaseCatalogAcc {
    constructor() {
        super(DesShareLibrarySearchResultsForTeamsViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {};
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale'];
    }
}

if (!window.customElements.get('des-share-library-search-results-for-teams')) {
    window.customElements.define('des-share-library-search-results-for-teams',
    DesShareLibrarySearchResultsForTeams);
}
